import { render } from "./DataFile.vue?vue&type=template&id=c69fca42&scoped=true"
import script from "./DataFile.vue?vue&type=script&lang=js"
export * from "./DataFile.vue?vue&type=script&lang=js"

import "./DataFile.vue?vue&type=style&index=0&id=c69fca42&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c69fca42"]])

export default __exports__